import React from 'react';

import classnames from 'classnames';
import { connect } from 'react-redux';
import { Elements } from 'react-stripe-elements';
import { StripeProvider } from 'react-stripe-elements';

import { MODALS } from 'global-constants';

import { injectScriptByUrl } from 'shared/utils/injectScript';

import Loader from 'shared/components/Loader';
import { withModal } from 'shared/components/Modals';

import PaymentForm from './PaymentForm';
import PlanTypes from './PlanTypes';
import ProfileForm from './ProfileForm';
import PaymentModal from './PaymentModal';

import { resetState, fetchPlanPrices, PAYMENT_STEPS } from './ducks';

import styles from './styles.module.scss';

class ChangePlanModal extends React.Component {
  state = {
    stripe: null,
    isLoading: true
  };

  componentDidMount() {
    this.props.fetchPlanPrices();

    this.addStripeToWindow();
  }

  addStripeToWindow() {
    if (window.Stripe) {
      return this.setStripeToState();
    }

    // create the script element
    const element = injectScriptByUrl({
      url: 'https://js.stripe.com/v3/',
      identifier: 'stripe-js'
    });

    // Create Stripe instance once Stripe.js loads
    element.addEventListener('load', this.setStripeToState);
  }

  setStripeToState = () =>
    this.setState({
      stripe: window.Stripe(`${process.env.REACT_APP_STRIPE_API_KEY}`),
      isLoading: false
    });

  closeModal = () => {
    this.props.closeModal();
    this.props.resetState();
  };

  render() {
    const { isLoading } = this.state;
    const { paymentStep, isFetchingPrices } = this.props;

    return isLoading || isFetchingPrices ? (
      <div className={styles.loaderWrapper}>
        <Loader />
      </div>
    ) : (
      <StripeProvider stripe={this.state.stripe}>
        <PaymentModal
          closeModal={this.closeModal}
          shouldHaveWhiteBackground={paymentStep !== PAYMENT_STEPS.SELECT_PLAN}>
          <div
            className={classnames(styles.changePlanModalWrapper, {
              [styles.whiteBackground]:
                paymentStep !== PAYMENT_STEPS.SELECT_PLAN
            })}>
            {paymentStep === PAYMENT_STEPS.SELECT_PLAN && <PlanTypes />}
            {paymentStep === PAYMENT_STEPS.PROFILE_FORM && <ProfileForm />}
            {paymentStep === PAYMENT_STEPS.MAKE_PAYMENT && (
              <div className={styles.paymentContent}>
                <div className={styles.headlineWrapper}>
                  <div className={styles.headline}>Pay securely</div>
                  <div className={styles.helpText}>
                    We use Stripe to make sure your payments are 100% secure.
                  </div>
                </div>
                <Elements>
                  <PaymentForm />
                </Elements>
              </div>
            )}
          </div>
        </PaymentModal>
      </StripeProvider>
    );
  }
}

const mapStateToProps = state => {
  const { paymentStep, isFetchingPrices } = state.changePlan;

  return { paymentStep, isFetchingPrices };
};
const mapDispatchToProps = {
  resetState,
  fetchPlanPrices
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withModal(MODALS.CHANGE_PLAN)(ChangePlanModal));
